import * as React from 'react';
import * as _ from 'lodash';
import { AlertTitle, AlertContent, AlertSubtext, AlertContainer } from './styles';
import { ReactComponent as IconError } from "common/images/icon-alert-red.svg"

export interface AlertProps {
    title: string
    subtitle: string
}

const Alert = (props: AlertProps) => {

    return (
        <AlertContainer>
            <IconError />
            <AlertContent>
                <AlertTitle>
                    {
                        props.title
                    }
                </AlertTitle>
                <AlertSubtext>
                    {
                        props.subtitle
                    }
                </AlertSubtext>
            </AlertContent>
        </AlertContainer>
    )
}
export default Alert

